module.exports = __webpack_public_path__ + "static/media/visa3x.abda6756.svg";